import { FetchProductCatalogRequest, ZincCatalog } from "@t3/shared";
import { createHttpsCallableHook } from "./createHttpsCallableHook";

export const useFetchProductCatalog = createHttpsCallableHook<
  FetchProductCatalogRequest,
  ZincCatalog
>("fetchProductCatalog");
